import { ACTIVITY_LAYERS } from "../../../constants/activityLibrary";

const COMMON_SHIFT_LABEL =
  ACTIVITY_LAYERS.find((l) => l.key === "common_shift")?.label ||
  "Common Shift Activities";

// Best-effort mapping from a Task module ADL subtask name to the closest
// Activity Library activityType constant (src/constants/activityLibrary.js).
// Falls back to the subtask name itself when nothing matches — the AI
// endpoint doesn't strictly validate this against the taxonomy.
const SUBTASK_ACTIVITY_TYPE = {
  "Vital Signs": "Vitals",
  Bowel: "Hygiene",
  "Body Care": "Hygiene",
  "Skin Care": "Hygiene",
  Hygiene: "Hygiene",
  "Nutrition and Hydration": "Meal",
  Meals: "Meal",
  Bed: "Sleep",
  Medication: "Medication",
  Other: "Routine Support",
};

// Builds the `activities` array for POST /note/ai-response/quick-note
// (src/services/quickNoteAi.js) from completed ADL checklist items — the
// same shape the Quick Notes picker sends (category/activityType/activity).
export function buildAdlActivitiesPayload(subTasks, checks) {
  if (!Array.isArray(subTasks) || !Array.isArray(checks) || checks.length === 0) {
    return [];
  }

  const items = [];
  subTasks.forEach((subTask) => {
    const subTaskName = subTask?.task?.name;
    const activityType = SUBTASK_ACTIVITY_TYPE[subTaskName] || subTaskName;
    (subTask?.fields || []).forEach((field) => {
      const check = checks.find((c) => c.field === field?._id);
      if (!check) return;
      items.push({
        category: COMMON_SHIFT_LABEL,
        activityType,
        activity: field?.name,
      });
    });
  });

  return items;
}
